export type CompanyPodcastOption = {
  podcastId: string;
  title: string;
  image?: string;
  igHandle?: string;
  hasMetaConnection: boolean;
};

export type MetaIgLinkedAsset = {
  pageId: string;
  pageName: string;
  igId: string;
  igUsername?: string;
  igProfilePictureUrl?: string;
};

export type MetaMappingRow = {
  pageId: string;
  igId: string;
  podcastId: string;
};

function normalizeHandle(value?: string | null): string {
  return (value ?? "").trim().replace(/^@+/, "").toLowerCase();
}

export function suggestPodcastForAsset(
  asset: MetaIgLinkedAsset,
  podcasts: CompanyPodcastOption[],
  usedPodcastIds: Set<string>,
): string {
  const igUsername = normalizeHandle(asset.igUsername);
  if (igUsername) {
    const byHandle = podcasts.find(
      (p) =>
        !usedPodcastIds.has(p.podcastId) &&
        normalizeHandle(p.igHandle) === igUsername,
    );
    if (byHandle) return byHandle.podcastId;
  }

  const pageName = (asset.pageName || "").trim().toLowerCase();
  if (pageName) {
    const byTitle = podcasts.find(
      (p) =>
        !usedPodcastIds.has(p.podcastId) &&
        (p.title || "").trim().toLowerCase() === pageName,
    );
    if (byTitle) return byTitle.podcastId;
  }

  return "";
}

export function buildSuggestedMappings(
  assets: MetaIgLinkedAsset[],
  selectedPodcasts: CompanyPodcastOption[],
): MetaMappingRow[] {
  // One row per podcast. Try to match each podcast to the best asset by IG handle,
  // then by page name. Fall back to the only asset when there is exactly one.
  return selectedPodcasts.map((podcast) => {
    const byHandle = assets.find(
      (a) => normalizeHandle(a.igUsername) === normalizeHandle(podcast.igHandle),
    );
    const defaultAsset = byHandle ?? (assets.length === 1 ? assets[0] : undefined);
    return {
      pageId: defaultAsset?.pageId ?? "",
      igId: defaultAsset?.igId ?? "",
      podcastId: podcast.podcastId,
    };
  });
}

export function validateMappings(
  mappings: MetaMappingRow[],
  selectedPodcastIds: string[],
): string | null {
  for (const row of mappings) {
    if (!row.pageId || !row.igId) {
      return "Asigna una cuenta de Instagram a cada podcast.";
    }
  }
  const podcastIds = mappings.map((m) => m.podcastId);
  if (new Set(podcastIds).size !== podcastIds.length) {
    return "Cada podcast solo puede aparecer una vez.";
  }
  for (const id of podcastIds) {
    if (!selectedPodcastIds.includes(id)) {
      return "Solo puedes vincular podcasts seleccionados en el paso anterior.";
    }
  }
  return null;
}
